import React, { memo, useEffect, useState } from 'react';
import { Column } from 'components/Layout/Grid';
import Text from 'components/Text';
import TextArea from 'components/TextArea';
import { useEnvironment } from 'hooks/useEnvironment';
import { EnvironmentTypes } from './interface';

const Description: React.FC<any> = (props) => {

  const { state, isEditing } = props;

  const development = useEnvironment();

  const [description, setDescription] = useState(
    state?.description || ''
  );

  useEffect(() => {
    const environment = process.env.REACT_APP_HOME_URL;

    if (!isEditing && (development || environment === EnvironmentTypes.dev || environment === EnvironmentTypes.qas)) {
      setDescription('Protocolo aberto pela equipe de desenvolvimento CCare - AP');
    }
  }, []);

  return (
    <Column className="mt-5 relative">
      <Text className="mb-2 color-blue-gray" size={12}>
        Descrição
      </Text>
      <TextArea
        stateName="description"
        id="description"
        onChange={(e) => setDescription(e.target.value)}
        value={description}
        minLength={10}
        name="Descrição"
        placeholder="Detalhe o ocorrido"
        required
        style={{
          flex: 1,
          height: 200,
          minHeight: 200,
        }}
      />
    </Column>
  );
};

export default memo(Description);
